import MenuOffCanvas from './MenuOffCanvas'
import { withRouter } from 'react-router-dom'

export default withRouter(MenuOffCanvas)



// WEBPACK FOOTER //
// ./src/components/MenuOffCanvas/index.js